import { useState } from "react";
import { Button, RoleBadge } from "../components";
import { useAuthenticatedSession, useSession } from "../session";
import styles from "./UserMenu.module.css";

/**
 * Qui est connecté, et la sortie. Rendu par la coquille dans les deux espaces,
 * au pied de la navigation — y compris dans le menu replié en largeur réduite :
 * se déconnecter ne doit jamais dépendre de la taille de l'écran.
 */
export function UserMenu() {
  const { user } = useAuthenticatedSession();
  const { logout } = useSession();
  const [enCours, setEnCours] = useState(false);

  async function quitter() {
    setEnCours(true);
    try {
      await logout();
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className={styles.utilisateur}>
      <div className={styles.identite}>
        <span className={styles.email} title={user.email}>
          {user.email}
        </span>
        <RoleBadge role={user.role} size="sm" />
      </div>
      <Button variant="secondary" size="sm" fullWidth onClick={() => void quitter()} loading={enCours}>
        Se déconnecter
      </Button>
    </div>
  );
}
